import { render } from "./SuccessAlert.vue?vue&type=template&id=1ab650f0&scoped=true"
import script from "./SuccessAlert.vue?vue&type=script&lang=js"
export * from "./SuccessAlert.vue?vue&type=script&lang=js"

import "./SuccessAlert.vue?vue&type=style&index=0&id=1ab650f0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ab650f0"]])

export default __exports__